import * as Enum from '@owl-nest/legacy-enum'

export const StickyStatus = Enum.create({
  PreSticky: 'pre-sticky',
  Sticky: 'sticky',
  PostSticky: 'post-sticky',
})
export type StickyStatus = Enum.ValueOf<typeof StickyStatus>

export type Offset = { top?: number; bottom?: number }
